export default defineNuxtPlugin((nuxtApp) => {
  let { cmsUrl, proxifyUrl } = useRuntimeConfig().public;
  cmsUrl = cmsUrl.replace(/\/+$/, '');
  proxifyUrl = proxifyUrl.replace(/\/+$/, '');

  const cmsApi = {
    get(endpoint, params = null, headers = {}) {
      endpoint = endpoint.replace(/^\/+/, '');

      return $fetch(`${cmsUrl}/api/${endpoint}`, {
        headers: {
          Accept: 'text/plain, application/json, */*',
          ...headers,
        },
        ...(params ? { params } : {}),
      });
    },
    post(endpoint, data, headers = {}) {
      endpoint = endpoint.replace(/^\/+/, '');

      return $fetch(`${cmsUrl}/api/${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...headers,
        },
        body: data,
      });
    },
  };

  const proxifyApi = {
    get(endpoint, headers = {}) {
      endpoint = endpoint.replace(/^\/+/, '');

      return $fetch(`${proxifyUrl}/api/${endpoint}`, {
        headers: {
          Accept: 'application/json',
          ...headers,
        },
      });
    },
    post(endpoint, data, headers = {}) {
      endpoint = endpoint.replace(/^\/+/, '');

      return $fetch(`${proxifyUrl}/api/${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...headers,
        },
        body: data,
      });
    },
  };

  nuxtApp.provide('cmsApi', cmsApi);
  nuxtApp.provide('proxifyApi', proxifyApi);
});
